var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsEnum, IsOptional, IsString, ValidateNested } from "class-validator";
import { LocalFileInfo } from "./file.dtos";
import { Type } from "class-transformer";
import { StudyTranslationLanguage } from "./study-translation-language.dtos";
export var TranscodeStatus;
(function (TranscodeStatus) {
    TranscodeStatus["UPLOADING"] = "UPLOADING";
    TranscodeStatus["TRANSCODING"] = "TRANSCODING";
    TranscodeStatus["COMPLETED"] = "COMPLETED";
    TranscodeStatus["FAILED"] = "FAILED";
})(TranscodeStatus || (TranscodeStatus = {}));
export class TranscodeDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], TranscodeDto.prototype, "id", void 0);
__decorate([
    ApiProperty({ enumName: "TranscodeStatus" }),
    IsEnum(TranscodeStatus),
    __metadata("design:type", String)
], TranscodeDto.prototype, "status", void 0);
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], TranscodeDto.prototype, "sourceUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], TranscodeDto.prototype, "hlsUrl", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], TranscodeDto.prototype, "mp4Url", void 0);
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: String,
    }),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], TranscodeDto.prototype, "thumbnailUrl", void 0);
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], TranscodeDto.prototype, "language", void 0);
__decorate([
    ApiPropertyOptional(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], TranscodeDto.prototype, "translatedFrom", void 0);
export function getPosterUrl(transcode) {
    var _a;
    if (!(transcode === null || transcode === void 0 ? void 0 : transcode.thumbnailUrl) || transcode.thumbnailUrl.length === 0)
        return null;
    return (_a = transcode.thumbnailUrl[Math.min(2, transcode.thumbnailUrl.length - 1)]) !== null && _a !== void 0 ? _a : null;
}
export class TranscodeInputBaseTranscodeDto {
}
__decorate([
    ApiProperty(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], TranscodeInputBaseTranscodeDto.prototype, "id", void 0);
export class TranscodeInput extends LocalFileInfo {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => TranscodeInputBaseTranscodeDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", TranscodeInputBaseTranscodeDto)
], TranscodeInput.prototype, "baseTranscode", void 0);
__decorate([
    IsString(),
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], TranscodeInput.prototype, "language", void 0);
export class TranscodeConflictErrorDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => TranscodeDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], TranscodeConflictErrorDto.prototype, "conflict", void 0);
